import axios from 'axios';
import { DeleteIcon, Edit, Save } from 'lucide-react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

interface LevelItem {
  id: number;
  level: number;
  f1: number;
  f2: number;
  f3: number;
  f4: number;
  f5: number;
  f6: number;
  f7: number;
}

const BetCommissionLevel = () => {
  const [levels, setLevels] = useState<LevelItem[]>([]);
  const [editLevel, setEditLevel] = useState<LevelItem | null>(null);
  
  const [newLevel, setNewLevel] = useState<LevelItem | Partial<LevelItem>>({});



  
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    navigate('/login');
  };

  // Fetch levels from the API
  const fetchLevels = async () => {
    try {
      const response = await axios.get('https://api.trubetx.com/admin/getLevelBetCommission');
      if (response.data) {
        setLevels(response.data.data);
      } else {
        toast('Failed to fetch levels.');
      }
    } catch (error) {
      console.error('Error fetching levels:', error);
      toast('Error fetching levels.');
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  // Handle input changes for editing levels
  const handleEditLevelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (editLevel) {
      const { name, value } = e.target;
      setEditLevel((prevLevel) => ({
        ...prevLevel!,
        [name]: value ? parseFloat(value) : 0,
      }));
    }
  };

  // Update an existing level
  const handleUpdateLevel = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editLevel) {
      try {
        const response = await axios.post(
          `https://api.trubetx.com/admin/updateLevelBetCommission/${editLevel.id}`,
          editLevel
        );
        if (response.data) {
          toast('Level updated successfully!');
          setEditLevel(null); // Clear the edit state
          fetchLevels();
        } else {
          toast('Failed to update level.');
        }
      } catch (error) {
        console.error('Error updating level:', error);
        toast('Error updating level.');
      }
    }
  };

  // Delete a level
  const handleDeleteLevel = async (id: number) => {
    try {
      const response = await axios.delete(`https://api.trubetx.com/admin/deleteLevelBetCommission/${id}`);
      if (response.data.status) {
        toast('Level deleted successfully!');
        fetchLevels();
      } else {
        toast('Failed to delete level.');
      }
    } catch (error) {
      console.error('Error deleting level:', error);
      toast('Error deleting level.');
    }
  };

  const handleNewLevelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewLevel((prev) => ({
      ...prev,
      [name]: value ? parseFloat(value) : 0,
    }));
  };
  

  const handleAddLevel = async (e: React.FormEvent) => {
    e.preventDefault();

  
    try {
      const response = await axios.post(
        'https://api.trubetx.com/admin/createLevelBetCommission',
        newLevel
      );
      if (response.data.status) {
        toast('Level added successfully!');
        setEditLevel(null); // Reset the form
        fetchLevels(); // Refresh the levels
      } else {
        toast(response.data.message || 'Failed to add level.');
      }
    } catch (error: any) {
      console.error('Error adding level:', error);
      toast(error.response?.data?.message || 'Error adding level.');
    }
  };
  

  // const filteredData = levels?.filter(item => item.level >= 0);

  const filteredData = levels.sort((a, b) => a.level - b.level);



  return (
    <div className="ml-0 p-4 bg-white">
      <h2 className="text-2xl font-semibold mb-4 text-black">Add New Level</h2>
      <hr className="p-5" />

      <div className="mb-8">
          <form onSubmit={handleAddLevel} className="space-y-4">
            <div>
              <label className="text-black">Level</label>
              <input
                type="number"
                name="level"
                value={newLevel?.level}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F1</label>
              <input
                type="number"
                name="f1"
                value={newLevel?.f1}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F2</label>
              <input
                type="number"
                name="f2"
                value={newLevel?.f2}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F3</label>
              <input
                type="number"
                name="f3"
                value={newLevel?.f3}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F4</label>
              <input
                type="number"
                name="f4"
                value={newLevel?.f4}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F5</label>
              <input
                type="number"
                name="f5"
                value={newLevel?.f5}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F6</label>
              <input
                type="number"
                name="f6"
                value={newLevel?.f6}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F7</label>
              <input
                type="number"
                name="f7"
                value={newLevel?.f7}
                onChange={handleNewLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
             <div className=" flex justify-start items-center gap-4">
                     <button
                   type="submit"
                      className="flex items-center gap-2 text-sm hover:text-blue-500 hover:scale-105 transition-transform  p-2 text-gray-700"
                    >
                      <Save size={20} />
                      <span>  Add Level</span>
                    </button>
                     
                   
                   
                  </div>
          </form>
        </div>

      {/* Edit Existing Level Form */}
      {editLevel && (
        <div className="mb-8">
          <h3 className="text-xl text-black">Edit Level</h3>
          <form onSubmit={handleUpdateLevel} className="space-y-4">
            <div>
              <label className="text-black">Level ID (Cannot be changed)</label>
              <input
                type="text"
                name="id"
                value={editLevel?.level}
                disabled
                className="border rounded p-2 w-full bg-gray-300"
              />
            </div>
            <div>
              <label className="text-black">F1</label>
              <input
                type="number"
                name="f1"
                value={editLevel?.f1}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F2</label>
              <input
                type="number"
                name="f2"
                value={editLevel?.f2}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F3</label>
              <input
                type="number"
                name="f3"
                value={editLevel?.f3}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F4</label>
              <input
                type="number"
                name="f4"
                value={editLevel?.f4}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F5</label>
              <input
                type="number"
                name="f5"
                value={editLevel?.f5}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F6</label>
              <input
                type="number"
                name="f6"
                value={editLevel?.f6}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="text-black">F7</label>
              <input
                type="number"
                name="f7"
                value={editLevel?.f7}
                onChange={handleEditLevelChange}
                className="border rounded p-2 w-full"
              />
            </div>
             <div className=" flex justify-start items-center gap-4">
                     <button
                   type="submit"
                      className="flex items-center gap-2 text-sm hover:text-blue-500 hover:scale-105 transition-transform  p-2 text-gray-700"
                    >
                      <Save size={20} />
                      <span>  Update Level</span>
                    </button>
                     <button
                    onClick={() => setEditLevel(null)}
                      className="flex items-center gap-2 text-sm hover:text-red-500 hover:scale-105 transition-transform  p-2 text-gray-700"
                    >
                      <DeleteIcon size={20} />
                      <span> Cancel</span>
                    </button>
                   
                   
                  </div>
          </form>
        </div>
      )}

      {/* Display Levels */}
      <div>
        {levels.length > 0 ? (
          <table className="table-auto w-full text-black text-center">
            <thead>
              <tr>
                <th className="border px-4 py-2">Level</th>
                <th className="border px-4 py-2">F1</th>
                <th className="border px-4 py-2">F2</th>
                <th className="border px-4 py-2">F3</th>
                <th className="border px-4 py-2">F4</th>
                <th className="border px-4 py-2">F5</th>
                <th className="border px-4 py-2">F6</th>
                <th className="border px-4 py-2">F7</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((level) => (
                <tr key={level.id}>
                  <td className="border px-4 py-2">{level.level}</td>
                  <td className="border px-4 py-2">{level.f1}</td>
                  <td className="border px-4 py-2">{level.f2}</td>
                  <td className="border px-4 py-2">{level.f3}</td>
                  <td className="border px-4 py-2">{level.f4}</td>
                  <td className="border px-4 py-2">{level.f5}</td>
                  <td className="border px-4 py-2">{level.f6}</td>
                  <td className="border px-4 py-2">{level.f7}</td>
                   <td className="border px-4 py-2 flex justify-center items-center gap-4">
                                       <button
                                      onClick={() => setEditLevel(level)}
                                        className="flex items-center gap-2 text-sm hover:text-blue-500 hover:scale-105 transition-transform  p-2 text-gray-700"
                                      >
                                        <Edit size={20} />
                                        <span> Edit</span>
                                      </button>
                                       <button
                                       onClick={() => handleDeleteLevel(level.level)}
                                        className="flex items-center gap-2 text-sm hover:text-red-500 hover:scale-105 transition-transform  p-2 text-gray-700"
                                      >
                                        <DeleteIcon size={20} />
                                        <span> Delete</span>
                                      </button>
                                     
                                     
                                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-black">No levels available at the moment.</p>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default BetCommissionLevel;
